import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import Home from './pages/home/index';
import UserForm from './components/questions/MerkezForm';
import YurtQuestions from './components/questions/YurtForm';
import NevaYemekForm from './components/questions/NevaYemekForm';
import JobList from './pages/jop-list/JobList';
import SuccessPage from './pages/SuccessPage/SuccessPage';
import YurtIlanForm from './components/İlanPages/YurtIlanForm';
import MerkezİlanForm from './components/İlanPages/MerkezİlanForm';
import Admin from './admin/AdminPanel';
import Politikamız from './pages/Politika/Politika';
import BasvuruDetay from './admin/Basvuru/BasvuruDetay';
import LoginPage from './admin/LoginPage';
import About from './pages/About/About';
import KVKK from './pages/KVKK/KVKK';

function ScrollManager() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navigationType]);
  return null;
}

const isAuthenticated = () => localStorage.getItem('isLoggedIn') === 'true';

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return children;
};

const Router = () => {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/merkez-ilanlar/:id" element={<UserForm />} />
        <Route path="/yurt-personel-ilanlar/:id" element={<YurtQuestions tip="yurt_personel" />} />
        <Route path="/yurt-yonetici-ilanlar/:id" element={<YurtQuestions tip="yurt_yonetici" />} />
        <Route path="/neva-yemek-ilanlar/:id" element={<NevaYemekForm />} />
        <Route path="/jobs-list" element={<JobList />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path='/yurt-ilan-ac' element={<YurtIlanForm />} />
        <Route path='/merkez-ilan-ac' element={<MerkezİlanForm />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path="/hakkımızda" element={<About />} />
        <Route path="/kvkk" element={<KVKK />} />
        <Route path='/admin' element={
          <ProtectedRoute><Admin /></ProtectedRoute>
        } />
        <Route path="/basvuru-detay/:id" element={
          <ProtectedRoute><BasvuruDetay /></ProtectedRoute>
        } />
        <Route path="/politika" element={<Politikamız />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;